module.exports = __webpack_public_path__ + "static/media/avatar.7337ac93.jpeg";